import { NgModule } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressBarModule} from '@angular/material/progress-bar';

import {MatCardModule} from '@angular/material/card';
import {MatTabsModule} from '@angular/material/tabs';
import {MatListModule} from '@angular/material/list';

import {MatIconModule} from '@angular/material/icon';

import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatFormFieldModule} from '@angular/material/form-field';

import {MatDatepickerModule} from '@angular/material/datepicker';

const MaterialComponents = [
  MatButtonModule,MatIconModule,MatProgressBarModule,MatCardModule,MatTabsModule,MatListModule,MatTooltipModule,MatButtonToggleModule,MatDatepickerModule,MatFormFieldModule
];

@NgModule({
  imports: [
    MaterialComponents,
  ],
  exports: [
    MaterialComponents

  ]
})
export class MaterialModule { }
